import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_4 = {
  title: `The system also <span style="color: #92D1FF;"> makes proactive \nsuggestions on Data Quality (DQ) checks \nbased on the attributes' types</span>, so \nVignesh just needs to review and accept \nthe recommendations.`,
  subtitle: "Data STREAMS demo",
  label: [{ iconPath: "start.png", text: "AI-first Innovation" }],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(209),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(207),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_04_computer.png",
          imageStyle: {
            position: "absolute",
            right: "73.59px",
            bottom: "247.35px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_04_screen.png",
          imageStyle: {
            position: "absolute",
            right: "169.62px",
            bottom: "357px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_04_eye.png",
          imageStyle: { position: "absolute", right: "155px", bottom: "80px" },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_04_check.png",
          imageStyle: { position: "absolute", right: "136px", bottom: "769px" },
        },
      ]}
      pageNumber={208}
    />
  ),
};
